﻿﻿﻿<div class="container-tab-lists">
    <div class="inner-tcontainer-tab">

        <h2>{{title}}</h2>

        <br />

        <div style="text-align:right; float:right">

            <button mat-raised-button type="button" (click)="save()" class="btn button-fix button-color-fix-orange pull-right">
                Save
                <mat-icon class="icon-color-fix">save</mat-icon>
            </button>
        </div>
        <sectionscheduler-list [list]="list"></sectionscheduler-list>
    </div> <!--inner-tcontainer-tab-->
</div> <!--container-tab-lists-->
